// Adaptive mobile sticky header — 3-state machine.
// Emits data-header-state="top" | "hidden" | "compact" on .header-group so CSS
// can drive per-state visibility (banner off in compact, second-row off on pages
// that don't earn it, etc.). Desktop is unaffected — CSS opts in via media query.

const floatHeader = document.getElementsByClassName("header-group")[0];

function throttle(func, wait, option = { leading: true, trailing: true }) {
  let timeout = null;
  let lastCallContext = null;
  let lastCallArgs = null;

  const later = () => {
    if (option.trailing && lastCallArgs) {
      func.apply(lastCallContext, lastCallArgs);
      lastCallContext = null;
      lastCallArgs = null;
      timeout = setTimeout(later, wait);
    } else {
      timeout = null;
    }
  };

  return function (...args) {
    if (timeout) {
      lastCallContext = this;
      lastCallArgs = args;
      return;
    }
    if (option.leading) {
      func.apply(this, args);
    } else {
      lastCallContext = this;
      lastCallArgs = args;
    }
    timeout = setTimeout(later, wait);
  };
}

// Thresholds: banner is ~40px, nav ~55px. "top" state ends once we've scrolled
// past the banner. HIDE_TRIGGER is the point at which a scroll-down starts
// hiding the header (matches previous behavior).
const TOP_STATE_MAX = 40;
const HIDE_TRIGGER = 100;

let lastOffsetHeader = 0;
let currentState = "top";

function setHeaderState(next) {
  if (next === currentState) return;
  currentState = next;
  floatHeader.setAttribute("data-header-state", next);
  if (next === "hidden") {
    floatHeader.style.top = "-200px";
  } else {
    floatHeader.style.top = "0px";
  }
  // Spec: icon-expanded search collapses on scroll. CSS hides the bar once
  // data-search-open is gone; the attribute is what kept it promoted.
  if (next !== "top") {
    floatHeader.removeAttribute("data-search-open");
  }
}

function handleFloatHeader() {
  // A sheet or drawer pins the body (useBodyScrollLock), which jumps scrollTop to 0 and
  // back. That isn't the shopper scrolling, so keep the header as it was.
  if (document.documentElement.hasAttribute("data-scroll-locked")) return;
  const scrollY = document.documentElement.scrollTop;
  if (scrollY === lastOffsetHeader) return;
  const scrollingUp = scrollY < lastOffsetHeader;

  if (scrollY <= TOP_STATE_MAX) {
    setHeaderState("top");
  } else if (scrollingUp) {
    setHeaderState("compact");
  } else if (scrollY >= HIDE_TRIGGER) {
    setHeaderState("hidden");
  }

  lastOffsetHeader = scrollY;
}

// Initialise attribute on load so CSS applies before first scroll.
if (floatHeader) {
  floatHeader.setAttribute("data-header-state", "top");
}

document.addEventListener(
  "scroll",
  throttle(handleFloatHeader, 100, { leading: false, trailing: true })
);
